import { graphql } from '@apollo/client/react/hoc';
import { DocumentNode } from 'graphql';

function mutation(mutation: DocumentNode, name: string) {
  return graphql(mutation, {
    name: name ? name : 'mutate',
  });
}

export default mutation;
